import React from 'react';
import Button from 'components/Buttons/Button';
import { CustomFieldPreset } from 'types/customField';
import 'twin.macro';
import { useTranslation } from 'react-i18next';
import Card from 'components/Card';
import { AutoSuggest } from 'components/Form/AutoSuggest';
import { SelectCustomField } from 'components/NewCustomFields/SelectCustomField';
import { NumberCustomField } from 'components/NewCustomFields/NumberCustomField';
import { BoolCustomField } from 'components/NewCustomFields/BoolCustomField';
import AttachmentsComponent from '@teetsh/app/src/components/Attachments/ButtonAttachment';
import Input from 'components/Form/Input2';
import { Tag } from 'components/Tag';
import { PaperClipIcon } from '@heroicons/react/24/outline';
import tw from 'twin.macro';
import InputGroup from 'components/Form/InputGroup';

function InputPreview({ customField }: { customField: CustomFieldPreset }) {
  switch (customField.type) {
    case 'multiselect': {
      return (
        <div tw="flex flex-col gap-0.5">
          {customField.value.map((v, i) => (
            <AutoSuggest
              key={i}
              options={customField.options.map(o => ({
                label: o.value,
                value: o.value,
              }))}
              value={v}
              onChange={() => {}}
            />
          ))}
        </div>
      );
    }

    case 'select': {
      return (
        <SelectCustomField
          options={customField.options}
          value={customField.value}
          allowMultipleValue
          onChange={() => {}}
          onUpdateOption={() => {}}
          onRemoveOption={() => {}}
          name=""
        />
      );
    }
    case 'number': {
      return (
        <NumberCustomField value={customField.value} onChange={() => {}} />
      );
    }
    case 'text': {
      return <Input value={customField.value} onChange={() => {}} />;
    }
    case 'phone': {
      return (
        <InputGroup
          value={customField.value}
          onChange={() => {}}
          withoutMargin
        />
      );
    }
    case 'filesAndMedia': {
      return (
        <>
          <AttachmentsComponent
            onChange={() => {}}
            handleError={() => {}}
            handleUploadAttachment={async () => {}}
          />
          <>
            {customField.value.map((v, idx) => (
              <div tw="flex max-w-[18rem]" key={idx}>
                <Tag
                  size="sm"
                  key={v.fileUrl}
                  icon={PaperClipIcon}
                  tw="h-[18px] cursor-zoom-in min-w-0"
                >
                  <span tw="truncate">{v.label}</span>
                </Tag>
              </div>
            ))}
          </>
        </>
      );
    }

    case 'bool': {
      return (
        <BoolCustomField
          name=""
          value={customField.value}
          onChange={() => {}}
        />
      );
    }
  }
}

export function CustomFieldPresetPreview({
  customField,
  onSelect,
}: {
  customField: CustomFieldPreset;
  onSelect: (field: CustomFieldPreset) => void;
}) {
  const { t } = useTranslation();
  return (
    <Card tw="flex flex-col gap-2 p-2! rounded-md" interactive>
      <div
        css={[
          tw`flex flex-col gap-2`,
          customField.type === 'bool' && tw`flex-row`,
        ]}
      >
        <span tw="text-sm font-medium text-neutral-moderate">
          {customField.name}
        </span>
        <InputPreview customField={customField} />
      </div>
      <div tw="flex justify-end">
        <Button
          type="button"
          small
          minimal
          onClick={() => onSelect(customField)}
        >
          {t('common:buttons.add')}
        </Button>
      </div>
    </Card>
  );
}
